import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';

/**
 * Серверное состояние живёт в кэше запросов и не дублируется в глобальном
 * store. Повторять запрос, отклонённый по правам или из-за отсутствия объекта,
 * бессмысленно — такие ошибки не ретраятся.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && [400, 401, 403, 404].includes(error.status)) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});
